import React from 'react';
import { svgToURL } from '../utils/svg';

const PromoPopover = ({ popover, children }) => {
  return (
    <>
      <aha-promo-popover
        placement='right-start'
        upgrade-location='whiteboards_stylus_toolbar_wireframe'
      >
        <div>{children}</div>
      </aha-promo-popover>
      <aha-promo-popover-content image-path={svgToURL(popover?.image)}>
        <div slot='title'>{popover?.title}</div>
        <div>{popover?.description}</div>
      </aha-promo-popover-content>
    </>
  );
};

export default PromoPopover;
